import { SignUp } from "@clerk/tanstack-react-start";
import { createFileRoute, redirect } from "@tanstack/react-router";

import { WorkEmailFormGuard } from "@/components/auth/work-email-guard";
import { useRedirectAfterAuth } from "@/hooks/use-redirect-after-auth";

export const Route = createFileRoute("/sign-up/$")({
  beforeLoad: async ({ context }) => {
    if (context.userId) {
      throw redirect({ to: "/app" });
    }
  },
  component: SignUpCatchAll,
});

function SignUpCatchAll() {
  useRedirectAfterAuth();

  return (
    <div className="flex flex-1 items-center justify-center px-4">
      <WorkEmailFormGuard>
        <SignUp routing="path" path="/sign-up" signInUrl="/sign-in" fallbackRedirectUrl="/app" />
      </WorkEmailFormGuard>
    </div>
  );
}
